export default "__VITE_ASSET__4WHvFCZh__"